import styles from './ActionButton.scss';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import lodash from 'lodash';

import { trackEvent } from 'components/common/GoogleAnalytics/GoogleAnalytics';
import {
    UserCanCreateBinders,
    UserCanUploadFiles,
} from 'common/permissions/components/actionButton';
import {
    openModal
} from 'common/actions/actionButtonActions';

export class ActionButton extends Component {
    handleActionButtonClick(e){
        const { actionButton } = this.props;
        if (this.props.actionButton.kind === 'modal') {
            this.props.openModal(this.props.actionButton.path);
        } else {
            this.props.push(actionButton.path);
        }
        this.trackEvent();
    }

    chooseActionButton() {
        const { kind } = this.props.actionButton;
        switch (kind) {
            case 'createBinder':
                return UserCanCreateBinders(Button);
            case 'uploadFiles':
                return UserCanUploadFiles(Button);
            default:
                return Button;
        }
    }

    trackEvent(){
        const { actionButton } = this.props;

        trackEvent({
            category: 'Action Button',
            action: actionButton.label,
        });
    }

    render() {
        const { actionButton } = this.props;
        if(!actionButton){
            return null;
        }
        if(!lodash.isString(actionButton.label) || !lodash.isString(actionButton.path)){
            return null;
        }
        if(actionButton.label === '' || actionButton.path === ''){
            return null;
        }

        const ButtonClass = this.chooseActionButton();
        return <ButtonClass actionButton={actionButton}
            handleActionButtonClick={this.handleActionButtonClick.bind(this)} />;
    }
}

export const Button = props => (
    <button className={styles.actionButton} onClick={props.handleActionButtonClick}>
        { props.actionButton.label }
    </button>
);

export default connect((state) => {
    const actionButton = lodash.get(state, ['app', 'actionButton'], {});
    return {
        actionButton
    };
},{
    push,
    openModal,
})(ActionButton);
